<template>
  <div id="app">
    <Header/>
    <transition  name="fade" mode="out-in">
      <router-view/>
    </transition>
    <Footer/>
  </div>
</template>



<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
export default {
  name: 'App',
  components:{
    Header,
    Footer
  }
}
</script>

<style>
@import "css/common.css";

</style>



// WEBPACK FOOTER //
// src/App.vue